"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconAddSmiley = Experimental__IconAddSmiley;
exports.IconAddSmiley = IconAddSmiley;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconAddSmiley/index.tsx)
 */
function IconAddSmiley(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M2 3.5v2h1.5v-2h2V2h-2V0H2v2H0v1.5h2Z\'/><path d=\'M1.52 7.487a4.846 4.846 0 0 1-1.436-.65A8 8 0 1 0 6.836.084c.29.435.512.918.65 1.436A6.5 6.5 0 1 1 1.52 7.487Z\'/><path d=\'M5.5 8.064c.552 0 1-.462 1-1.032C6.5 6.462 6.052 6 5.5 6s-1 .462-1 1.032c0 .57.448 1.032 1 1.032Zm5 0c.552 0 1-.462 1-1.032 0-.57-.448-1.032-1-1.032s-1 .462-1 1.032c0 .57.448 1.032 1 1.032Zm.652 1.547H4.848c-.192 0-.35.156-.327.347C4.678 11.278 5.747 12.5 8 12.5s3.322-1.222 3.48-2.542c.022-.19-.136-.347-.328-.347Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M5 0H3v3H0v2h3v3h2V5h3V3H5V0Z\'/><path d=\'M3.001 12.15a7.275 7.275 0 0 1-1.972-.96c-.02.267-.029.538-.029.81 0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1c-.273 0-.543.01-.811.03a7.24 7.24 0 0 1 .96 1.971 9 9 0 1 1-9.148 9.149Z\'/><path d=\'M8.317 11.56c.865 0 1.567-.685 1.567-1.53S9.182 8.5 8.317 8.5s-1.567.685-1.567 1.53.702 1.53 1.567 1.53Zm7.313 0c.865 0 1.567-.685 1.567-1.53S16.495 8.5 15.63 8.5s-1.567.685-1.567 1.53.702 1.53 1.567 1.53Zm1.284 2.04H7.098a.328.328 0 0 0-.334.348C6.923 16.026 8.52 18 12.006 18c3.485 0 5.084-1.974 5.243-4.052a.328.328 0 0 0-.335-.347Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconAddSmiley is deprecated and will be archived soon. Use IconAddSmiley instead.
 */
function Experimental__IconAddSmiley(props) {
  return /*#__PURE__*/_react["default"].createElement(IconAddSmiley, props);
}